/*
  HODL Vault – Produkt- und Kollektionsseiten
  Marken-Filter im Kollektionskopf: filtert die Karten dieser Seite sofort,
  Karten gleiten an ihren neuen Platz (FLIP, nur transform). Ohne Skript bleibt
  der Filter verborgen und das Raster vollständig.
  Raster und Karten werden bei jedem Klick neu gesucht, weil die Be-Yours-Filter
  (Verfügbarkeit, Preis) das Raster per AJAX ersetzen; danach steht der Filter wieder auf «Alle».
*/
(() => {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ease = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

  const initBrandFilter = (scope) => {
    scope.querySelectorAll('[data-vch]').forEach((root) => {
      if (root.dataset.vchInit) return;
      const filter = root.querySelector('[data-vch-filter]');
      const gridNow = () => d.querySelector('#ProductGridContainer .product-grid') || d.querySelector('.product-grid');
      if (!filter || !gridNow() || gridNow().children.length < 2) return;
      root.dataset.vchInit = '1';
      filter.hidden = false;
      const count = root.querySelector('[data-vch-count]');
      let total = count ? count.textContent : '';
      const chips = Array.from(filter.querySelectorAll('[data-vch-brand]'));
      const beyoursCount = () => d.querySelectorAll('.template-collection .product-count');

      const press = (active) => {
        chips.forEach((c) => {
          const on = c === active;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      const apply = (brand, ruhig) => {
        const grid = gridNow();
        if (!grid) return;
        const items = Array.from(grid.children);
        const before = new Map(items.map((el) => [el, el.getBoundingClientRect()]));
        let shown = 0;
        items.forEach((el) => {
          const hit = !brand || (el.textContent || '').toLowerCase().includes(brand);
          el.classList.toggle('vch-hidden', !hit);
          if (hit) shown += 1;
        });
        if (count) count.textContent = brand ? String(shown) : total;
        // Die Be-Yours-Zählung kennt den Marken-Filter nicht; solange er aktiv ist, zählt der Kopf.
        beyoursCount().forEach((el) => { el.style.visibility = brand ? 'hidden' : ''; });
        if (reduce || ruhig) return;
        items.forEach((el) => {
          if (el.classList.contains('vch-hidden')) return;
          const a = before.get(el);
          const b = el.getBoundingClientRect();
          if (!a || (a.width === 0 && a.height === 0)) {
            el.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: ease });
            return;
          }
          const dx = a.left - b.left;
          const dy = a.top - b.top;
          if (dx || dy) {
            el.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 480, easing: ease });
          }
        });
      };

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          press(chip);
          apply(chip.dataset.vchBrand || '');
        });
      });

      // Marke aus der Adresse vorwählen (?marke=tangem), etwa für Menülinks auf eine Marke; beim Laden ohne Animation.
      const wunsch = (new URLSearchParams(window.location.search).get('marke') || '').trim().toLowerCase();
      const vorwahl = wunsch ? chips.find((c) => (c.dataset.vchBrand || '') === wunsch) : null;
      if (vorwahl) {
        press(vorwahl);
        apply(wunsch, true);
      }

      // Neues Raster nach Be-Yours-Filter: Marken-Filter zurücksetzen, Zahl aus der Be-Yours-Zählung übernehmen.
      const container = d.getElementById('ProductGridContainer');
      if (container && 'MutationObserver' in window) {
        new MutationObserver(() => {
          press(chips[0]);
          beyoursCount().forEach((el) => { el.style.visibility = ''; });
          const text = (d.getElementById('ProductCountDesktop') || d.getElementById('ProductCount') || {}).textContent || '';
          const n = text.match(/\d+/);
          if (n && count) {
            total = n[0];
            count.textContent = total;
          }
        }).observe(container, { childList: true });
      }
    });
  };

  const init = (scope = d) => initBrandFilter(scope);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => init());
  else init();
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
